/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_ConflictingInputs */

const en_directory_agent_readiness_status_conflicting = /** @type {(inputs: Directory_Agent_Readiness_Status_ConflictingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflicting official information`)
};

const zh_directory_agent_readiness_status_conflicting = /** @type {(inputs: Directory_Agent_Readiness_Status_ConflictingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方信息存在冲突`)
};

/**
* | output |
* | --- |
* | "Conflicting official information" |
*
* @param {Directory_Agent_Readiness_Status_ConflictingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_conflicting = /** @type {((inputs?: Directory_Agent_Readiness_Status_ConflictingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_ConflictingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_conflicting(inputs)
	return zh_directory_agent_readiness_status_conflicting(inputs)
});
export { directory_agent_readiness_status_conflicting as "directory.agent_readiness.status.conflicting" }